<template>
    <div>
        <div ref="deliveryTrendChart" style="height: 350px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    export default {
        data () {
            return {
                chart: null,
            }
        },
        mounted () {
            this.createChart();
        },
        methods : {
            createChart () {
                // Create chart instance
                this.chart = am4core.create(this.$refs.deliveryTrendChart, am4charts.XYChart);


                // Add data
                this.chart.data = [{
                    "month": "January",
                    "in-transit": 250,
                    "received-by-dealer": 250
                }, {
                    "month": "February",
                    "in-transit": 260,
                    "received-by-dealer": 270
                }, {
                    "month": "March",
                    "in-transit": 280,
                    "received-by-dealer": 290
                }];

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "month";
                categoryAxis.renderer.grid.template.location = 0;


                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.inside = true;
                valueAxis.renderer.labels.template.disabled = true;
                valueAxis.min = 0;

                // Create series
                let createSeries = (field, name) => {
                
                    // Set up series
                    let series = this.chart.series.push(new am4charts.ColumnSeries());
                    series.name = name;
                    series.dataFields.valueY = field;
                    series.dataFields.categoryX = "month";
                    series.sequencedInterpolation = true;
                    
                    // Make it stacked
                    series.stacked = true;
                    
                    // Configure columns
                    series.columns.template.width = am4core.percent(60);
                    series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
                    
                    // Add label
                    let labelBullet = series.bullets.push(new am4charts.LabelBullet());
                    labelBullet.label.text = "{valueY}";
                    labelBullet.locationY = 0.5;
                    labelBullet.label.hideOversized = true;
                    
                    return series;
                }

                createSeries("in-transit", "In Transit");
                createSeries("received-by-dealer", "Received By Dealer");

                // Legend
                this.chart.legend = new am4charts.Legend();

            }
        }
    }
</script>